import { render, staticRenderFns } from "./ForgotPasswordOldUser.vue?vue&type=template&id=d980c9ba&"
import script from "./ForgotPasswordOldUser.vue?vue&type=script&lang=js&"
export * from "./ForgotPasswordOldUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports